module.exports = __webpack_public_path__ + "img/chat.acc97649.svg";